import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { SendComponent } from '@app/client/uploader/desktop/modules/send/send.component';
import * as fromUploader from '@app/client/uploader/store/reducers';
import { getPathWithoutLastFragment } from '@app/shared/helpers/location';
import { Store } from '@ngrx/store';
import { Observable, ReplaySubject, of } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { isPlatformServer } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class DropboxCreatedGuard {

  constructor(
    private store$: Store<fromUploader.State>,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: object,
  ) { }

  canActivate(): Observable<boolean> {
    if (isPlatformServer(this.platformId)) {
      return of(true)
    }
    return this.isDropboxCreated().pipe(map((dropboxCreated) => {
      return dropboxCreated;
    }));
  }

  canDeactivate(component: SendComponent) {
    return (() => component.canDeactivate())();
  }

  isDropboxCreated(): Observable<boolean> {
    const isDropboxCreated$ = new ReplaySubject<boolean>();
    this.store$.select(fromUploader.getDropbox).pipe(
      takeUntil(isDropboxCreated$)
    ).subscribe((dropbox) => {
      if (dropbox?.id) {
        isDropboxCreated$.next(true);
      } else {
        this.router.navigate([getPathWithoutLastFragment()]);
        isDropboxCreated$.next(false);
      }
    });
    return isDropboxCreated$.asObservable();
  }

}
